import { makeAutoObservable } from 'mobx';
import i18n from '@/i18n';
import { GetFieldDistinctData } from '@/presentation/components/issue-dashboard/api';
import { FieldKey } from '@/proto/field';
import { MetricType } from '@/proto/metric';

// 全版本标识：直接用 i18n.t('全版本') 求值的“当前语言文案”同时作为 option 的 value 与 label。
// 之所以可以用模块级常量固化：本项目切换语言走整页 reload（见 src/i18n/use-locale.ts），
// reload 后该常量按新语言重新求值，全局所有“是否全版本”的比较点与 option.value 用的都是同一份文案，天然一致。
// 注意：所有比较/默认值都应使用 ALL_VERSION_NAME（或组件内的 t('全版本')），切勿再硬编码中文 '全版本'，否则英文下会失配。
export const ALL_VERSION_NAME = i18n.t('全版本');

export const appFilterOption = (input: string, option: { value: string, label: string }|undefined) => {
  const keyword = (input ?? '').toLowerCase();
  const label = (option?.label ?? '').toLowerCase();
  const value = (option?.value ?? '').toLowerCase();
  return label.includes(keyword) || value.includes(keyword);
};
export class OverviewStore {
  appVersionOptions: { label: string, value: string}[] = [
    { value: ALL_VERSION_NAME, label: ALL_VERSION_NAME },
  ];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async getFieldDistinctData(
    field: FieldKey,
    type: MetricType,
  ) {
    const values =  await GetFieldDistinctData(field, type);
    const options = values.map(item => ({ value: item, label: item }));
    options.unshift({ value: ALL_VERSION_NAME, label: ALL_VERSION_NAME });
    this.appVersionOptions = options;
  };
}
